import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Footer from './Footer';
import { PAGE_TITLES } from '../navigation/pageTitle';
import { setCanonical } from '../navigation/canonical';
import Logo from './ui/Logo';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = PAGE_TITLES.notFound;
    setCanonical(null);
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="container mx-auto px-5 py-16">
        <Logo size="lg" wordmark={false} decorative className="mb-6" />
        <h1 className="text-3xl font-bold mb-4 break-words">{t('notFound.title')}</h1>
        <p className="mb-6 break-words">{t('notFound.body')}</p>
        <Link to="/" className="link">
          {t('nav.home')}
        </Link>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
